import type { BeforeRequestHook } from "ky";

import { logOut } from "@/redux/actions/logout";
import store from "@/redux/store";

import type { ApiContext } from "../../types";

const dispatch = store.dispatch;

export function authorizationHookFactory(getToken: () => string | null): BeforeRequestHook {
  return ({ options, request }) => {
    const context = options.context as ApiContext | undefined;
    const token = context?.accessToken ?? getToken();

    if (!token) {
      dispatch(logOut());

      return new Response(JSON.stringify({ error: { message: "Missing authentication token" } }), {
        headers: { "Content-Type": "application/json" },
        status: 401,
      });
    }

    request.headers.set("Authorization", token);
    request.headers.set("Accept", "application/json");
    request.headers.set("x-location-path-name", window.location.pathname);

    return undefined;
  };
}
